import type { ReactNode } from "react";
import {
  ContextMenuItem,
  ContextMenuSeparator,
} from "@/shared/components/ui/context-menu";
import type { PlayerChange } from "../setup.overrides";
import type { SetupPlayer } from "../setup.types";
import { PlayerContextMenu } from "./PlayerContextMenu";

export function BossPlayerContextMenu({
  player,
  onChange,
  onEditStandIn,
  onDeleteStandIn,
  onSelectAll,
  onSelectNone,
  children,
}: {
  player: SetupPlayer;
  onChange: (change: PlayerChange) => void;
  onEditStandIn: (player: SetupPlayer) => void;
  onDeleteStandIn: (id: string) => void;
  onSelectAll: () => void;
  onSelectNone: () => void;
  children: ReactNode;
}) {
  return (
    <PlayerContextMenu
      player={player}
      onChange={onChange}
      onEditStandIn={onEditStandIn}
      onDeleteStandIn={onDeleteStandIn}
      leadingItems={
        <>
          <ContextMenuItem onSelect={onSelectAll}>Alla bossar</ContextMenuItem>
          <ContextMenuItem onSelect={onSelectNone}>Inga bossar</ContextMenuItem>
          <ContextMenuSeparator />
        </>
      }
    >
      {children}
    </PlayerContextMenu>
  );
}
